const CrawlSummaryColumns = [
  {
    title: 'Domain',
    dataIndex: 'domain',
    width: 200,
    slot: 'domain',
  },
  {
    title: 'Initial URL',
    dataIndex: 'initialURL',
    width: 200,
    slot: 'initialURL',
  },
  {
    title: 'User Agent',
    dataIndex: 'userAgentId',
    width: 200,
    slot: 'userAgentId',
  },
  {
    title: 'Depth',
    dataIndex: 'depth',
    width: 100,
    slot: 'depth',
  },
  {
    title: 'Started On',
    dataIndex: 'startedOn',
    width: 150,
    slot: 'startedOn',
  },
  {
    title: 'Ended On',
    dataIndex: 'endedOn',
    width: 150,
    slot: 'endedOn',
  },
  {
    title: 'Crawl Status',
    dataIndex: 'crawlStatus',
    width: 100,
    slot: 'crawlStatus',
  },
];

export { CrawlSummaryColumns };
